import { render, staticRenderFns } from "./invite_members_trigger.vue?vue&type=template&id=51a97790&vue3"
import script from "./invite_members_trigger.vue?vue&type=script&lang=js&vue3"
export * from "./invite_members_trigger.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports